export default ['amount', 'percent'];
